import { BodyS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/topUpAddOns/topUpCardStyle';
import { makeStyles } from '@material-ui/styles';
import SingleTopUpValue from './SingleTopUpValue';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ITopUpValuesProps {
	topUpValue?: number;
	setTopUpValue?: React.Dispatch<React.SetStateAction<number>>;
}

const TopUpValues = ({ topUpValue, setTopUpValue }: ITopUpValuesProps) => {
	const classes = useStyles();
	return (
		<>
			<BodyS color="secondary-light">{translate('payments.topup.topupValue')}</BodyS>
			<div className={classes.topupValueContainer}>
				{[1, 3, 5, 10].map((value) => (
					<SingleTopUpValue
						key={value}
						checked={topUpValue === value}
						value={value}
						setTopUpValue={setTopUpValue}
					/>
				))}
			</div>
		</>
	);
};

export default TopUpValues;
